import { FC } from "react";

import { Button, CloseButtonAppearance, Icon } from "../../../general";

import { AgentChatAttachment, ChatbotClassMap } from "../types";

interface Props {
  readonly styles: ChatbotClassMap;
  readonly file: AgentChatAttachment;
  readonly onRemove?: (id: string) => void;
}

/* A file chip. Shows a remove button when onRemove is given (compose input); otherwise read-only (message history). */
export const AttachmentChip: FC<Props> = ({ styles, file, onRemove }) => (
  <span className={styles.AttachmentChip} title={file.name}>
    <Icon name="attachment" size="small" aria-hidden="true" />
    <span className={styles.AttachmentChipName}>{file.name}</span>
    {!!onRemove && (
      <Button
        icon="x"
        appearance={CloseButtonAppearance}
        size="small"
        aria-label={`Remove ${file.name}`}
        onClick={() => onRemove(file.id)}
        testId={`remove-file-${file.id}`}
      />
    )}
  </span>
);
